<div  class="row" [class.form-group]="!group.disabled" >
  <!-- label form -->
  <label *ngIf="(group.enabled || config.presentation === 'filter' || config.presentation === 'detail') || (config.presentation === 'edit'
  && config.options.labelShowInDetail)" for="{{config.label}}" class="col-sm-3 control-label" style="white-space: nowrap;">
    {{config.label | translate:locale.language}}
  </label>
  <div class="col-sm-9 parent-container">
    <!--  normal form  -->
    <div *ngIf="group.enabled && config.presentation === 'edit'" style="width: 100%;">
      <div class="input-group" style="width: 100%; margin: 0 5px 0 0;zoom:75%" >
        <span *ngIf="!isDisabled && config.options.datePicker.checkboxEndlessMode" class="input-group-addon container-checkbox">
          <input type="checkbox" class="form-check-input" [checked]="endLessDate" (change)="checkboxChange($event)">
          <span class="checkmark"></span>
        </span>
        <span *ngIf="!isDisabled" class="input-group-addon"><i class="fa fa-calendar"></i></span>
        <span *ngIf="!isDisabled && !endLessDate">
              <input type="text"
                  placeholder="Period"
                  class="form-control"
                  [minDate]="minDate"
                  (bsValueChange)="applyFilter($event)"
                  [bsConfig]="{ ranges: ranges , dateInputFormat: 'DD/MM/YYYY'}"
                  bsDaterangepicker>
              </span>
        //   (bsValueChange)="applyFilter($event)"
        <span *ngIf="!isDisabled &&  endLessDate" class="form-control disabled endLessDate" >{{config.options.datePicker.checkboxEndlessModeText | translate:locale.language}}</span>
      </div>
      <!-- errors form -->
      <div>
        <span *ngIf="group.get(config.controlName[0]).invalid && !group.get(config.controlName[0]).value" class="icon-mandatory">*</span>
      </div>
    </div>

    <!-- filter form -->
    <div *ngIf="config.presentation === 'filter'" style="width: 100%;">
      <div class="input-group" style="width: 100%;" >
        <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
        <span>
              <input id="{{config.label}}"
                     type="text"
                     class="form-control"
                     [(ngModel)]="defaultValue"
                     (bsValueChange)="applyFilter($event)"
                     [bsConfig]="{ ranges: ranges , dateInputFormat: 'DD/MM/YYYY'}"
                     bsDaterangepicker>
              </span>
      </div>
    </div>

    <!-- presentation form  -->
    <div *ngIf="(group.disabled && (group.get(config.controlName[0]).value)?.length) || config.presentation === 'detail'" style="font-weight: bold; margin-top: 2px">
     <span  *ngIf="(group.get(config.controlName[0]).value|date:'dd/MM/yyyy') !== '31/12/2099'">
       {{ group.get(config.controlName[0]).value && group.get(config.controlName[0]).value !== 'Invalid date' ? (group.get(config.controlName[0]).value|date:'dd/MM/yyyy') : ''}}</span>
      <span *ngIf="(group.get(config.controlName[0]).value|date:'dd/MM/yyyy') === '31/12/2099'" class="endLessDate" >{{config.options.datePicker.checkboxEndlessModeText | translate:locale.language}}</span>
    </div>

  </div>
</div>

<div *ngIf="false">
  <!--  <pre>minDate:{{minDate}}</pre>-->
  <!--  <pre>maxDate:{{maxDate}}</pre>-->
  <!--  <pre>defaultDate:{{defaultDate}}</pre>-->
  <!--  <pre>useCurrent:{{useCurrent}}</pre>-->
  <pre>date form:{{group.get(config.controlName[0]).value}}</pre>
  <!--  <pre>dateToShow:{{dateToShow}}</pre>-->
  <!--  <pre>presentation:{{this.config.presentation}}</pre>-->
  <!--  <pre>dirty:{{this.group.dirty}}</pre>-->
  <!--  <pre>valid:{{this.group.valid}}</pre>-->
  <!--  <pre>with format:{{group.get(config.controlName[0]).value|date:'dd/MM/yyyy'}}</pre>-->
  <!--<pre>{{startDateOptions|json}}</pre>-->
</div>

